module.exports = __webpack_public_path__ + "img/02.b6cec4cd.png";